import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { tap } from 'rxjs';
import type { BusinessDocuments } from '../../../common/interfaces/documents/business-documents';
import { DocumentsService } from '../../../dashboard/management-panel/documents/common/services/documents.service';
import { AuthStore } from '../stores/auth.store';

export const registerDocumentsResolver: ResolveFn<BusinessDocuments> = () => {
  const authStore = inject(AuthStore);
  const documentsService = inject(DocumentsService);

  return documentsService
    .getDocuments()
    .pipe(tap((documents) => authStore.setDocuments(documents)));
};
